import React from 'react';
import WaiterLayout from '../../components/WaiterLayout';
import RestaurantOrderPage from '../../modules/restaurant/pages/Orders/RestaurantOrderPage';

/** Waiter order-taking entry point — same ordering UI as the cashier POS, minus the billing step (gated server- and client-side by Orders.Settle). */
const WaiterNewOrderPage: React.FC = () => (
  <WaiterLayout>
    <RestaurantOrderPage cashierMode />
  </WaiterLayout>
);

export default WaiterNewOrderPage;
